<template>
    <div class="editor-component">
        <TextareaComponent 
            ref="textarea"
            :id="id"
            :textareaValue="text"
            v-on:setTextareaValue="setTextareaContentValue"    
            @clickTextarea="clickTextarea" 
            @doubleclickTextarea="doubleclickTextarea" 
            @onBlurTextarea="onBlurTextarea"
            @keyDown="keyDownTextarea"
            
            :maxCharacters="maxCharacters"
            :showOptionBold="showOptionBold"
            :showOptionItalic="showOptionItalic"
            :showOptionUnderline="showOptionUnderline"
            :ShowCounterCharacters="ShowCounterCharacters"
            :textInfoMaxCharacters="textInfoMaxCharacters"
        />
    
 
        <div class="btns">
            <div class="btn" @click="clickHashtag" :class="{'disable': !this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)}">
                <i class="fa-solid fa-hashtag"></i>
                Hashtags
            </div>
            <div class="btn" @click="clickMention" :class="{'disable': !this.pagesSelected.find(p => ['facebook','instagram','inkedin', 'twitter'].includes(p.network))}">
                <i class="fa-solid fa-at"></i>
                Mentions
            </div>
        </div>
    </div>
</template>

<script>

    import { EventBus } from '@/event-bus';
    import store from './../../../store/index.js';
    import TextareaComponent from './Textarea.vue'
    import minxinBot from '../../mixins/Bots.vue'

    export default {
        components: {
            TextareaComponent,
        },
        mixins: [minxinBot],

        props: {
            id: {
                type: String,
                default: ''
            },
            text: {
                type: String,
                default: ''
            },
            mentions: {
                type: Object,
                default: ()=>({})
            },

            maxCharacters: {
                type: Number,
                default: Infinity
            },

            textInfoMaxCharacters:{
                type: String,
                default: ''
            },

            showOptionBold: {
                type: Boolean,
                default: true
            },
            showOptionItalic: {
                type: Boolean,
                default: true
            },
            showOptionUnderline: {
                type: Boolean,
                default: true
            }, 
            ShowCounterCharacters: {
                type: Boolean,
                default: true
            },
        },

        data() {
            return {
                idMentionSelected: null,

                clickTextareaTimeout : null,
                keyAtPressedEvent : {
                    flag: false,
                    indexInWord: null
                },
            }
        },

        created () {
            EventBus.$on('eventCloseSelectMention', this.closeSelectMention);
            EventBus.$on('eventClickSelectMention', this.addMention);
            EventBus.$on('eventSearchFromSelectMention', this.searchMention);
            EventBus.$on('eventRemoveSelectMention', this.removeMention);
            EventBus.$on('eventSearchFromSelectHashtags', this.searchHashtags);
            EventBus.$on('eventApplyFromSelectHashtags', this.addHashtags); 
            
        },

        mounted () {
            this.updateHtmlTextarea(false);
        },
        
        watch: {
            text(newValue, oldValue) {
                this.updateHtmlTextarea(false);  
            }
        },

        methods: {
            
             /////////////// Textarea Content START ///////////////

            //EMIT
            setTextareaContentValue(innerHTML,e) {

                function escapeSpecialChars(str) {
                    // Remplacer les caractères échappés par leurs équivalents littéraux
                    return str
                    .replace(/\\/g, '\\\\')   // Backslash '\\'
                    .replace(/\n/g, '\\n')     // Newline '\n'
                    .replace(/\t/g, '\\t')     // Tab '\t'
                    .replace(/\r/g, '\\r')     // Carriage return '\r'
                    .replace(/\f/g, '\\f')     // Form feed '\f'
                    .replace(/\v/g, '\\v')    // Vertical tab '\v'
                    .replace(/ /g, '&nbsp;')  // Space ' ' -> '&nbsp;'
                    .replaceAll(" ", '&nbsp;')
                    .replace(/\u00A0/g, "&nbsp;");
                }

                console.log('----------------------- setTextareaContentValue START--------------------------')


                const div = document.createElement('div');
                div.innerHTML = innerHTML.replace(/<br>/g, '\n');



                let forceUpdate = false;
                div.querySelectorAll('.tag-mention').forEach(element => {
                    let textDefault = element.innerHTML.slice(1)
                    let textClean = this.cleanTextMention(textDefault)
                    
                    if (textClean !== textDefault) forceUpdate = true
                    
                    this.$emit('setMention', element.getAttribute("idmention"), {
                        ...this.mentions[element.getAttribute("idmention")],
                        textDefault: textClean
                    })
                    
                    element.innerHTML = `@${element.getAttribute("idmention")}`
                });

                console.log("innerText avant escapeSpecialChars",div.innerText)
                let innerText = escapeSpecialChars(div.innerText)

                console.log("innerHTML",div.innerHTML)
                console.log("innerText",innerText,innerText.length)

                console.log('detecter le debut d\'une mention', e, forceUpdate)
                //detecter le debut d'une mention
                if (!forceUpdate && e && e.data && e.data == '@') {
                   
                    const currentValue = this.text
                    const newValue = innerText
                    console.log("currentValue", currentValue)
                    console.log("newValue",newValue)
                    const position = newValue.split('').findIndex((char, index) => (currentValue[index] !== char));
                    // console.log('position',position)
                    let startText = newValue.slice(0,position)
                    let endText = newValue.slice(position+1)


                    // console.log('startText', startText)
                    // console.log('endText', endText)

                    const delimiters = [' ', '&nbsp;', '\\n', '\n', '</br>', '.', ';'];

                    // Trouver le début du mot
                    let startWordPosition = Math.max(...delimiters.map(d => {
                        const matchPosition = startText.lastIndexOf(d)
                        return matchPosition >= 0 ? matchPosition + d.length : 0
                    }));
                    
                    const lastMentionPosition = this.findOneMentionPosition(startText.slice(startWordPosition), true)
                    if (lastMentionPosition >= 0) startWordPosition = startWordPosition + lastMentionPosition + 14
                    
                    // Trouver la fin du mot
                    let endWordPosition = Math.min(...delimiters.map(d => {
                        const matchPosition = endText.indexOf(d)
                        return matchPosition >= 0 ? matchPosition : endText.length
                    }), endText.length);

                    const firstMentionPosition = this.findOneMentionPosition(endText.slice(0,endWordPosition))
                    if (lastMentionPosition >= 0) endWordPosition = firstMentionPosition            

                    this.idMentionSelected = (new Date).getTime()

                    const mention = {
                        textDefault : startText.slice(startWordPosition) + endText.slice(0, endWordPosition),
                        mention : {}
                    }
                    

                    this.$emit('setMention', this.idMentionSelected, mention)
    
                    innerText = startText.slice(0, startWordPosition) + `@${this.idMentionSelected}` + (endText.slice(endWordPosition).replaceAll('\n','').replaceAll('\\n','').length ? endText.slice(endWordPosition) : '&nbsp;'+endText.slice(endWordPosition));
                    
                    
                    // console.log('innerHtml',"|"+div.innerText+"|");
                    this.keyAtPressedEvent = {
                        flag: true,
                        indexInWord: startText.slice(startWordPosition).length
                    }
                    this.$emit('setText',innerText)

                    this.$nextTick(() => {
                        this.updateHtmlTextarea()
                        this.addMode("addMentionMode",{
                            mention : {
                               ...mention,
                               textDefault: mention.textDefault ? mention.textDefault.replaceAll('&nbsp;',' ') : ''
                            },
                            idMention : this.idMentionSelected
                        })
                    })
                    

                    return

                }

                //const textMentionAroundSpace = innerText.replace(/(?:&nbsp;)?(@\d{13})(?:&nbsp;)?/g, '&nbsp;$1&nbsp;');
                let indexLastMention = null
                let textMentionAroundSpace = innerText.split(/(@\d{13})/).filter(v => v !== "")
                console.log("Split textMentionAroundSpace", textMentionAroundSpace)
                textMentionAroundSpace = textMentionAroundSpace.map((currentValue, index, array) => {
                    if (currentValue.length == 14 && currentValue.slice(0,1) == '@' && !isNaN(currentValue.slice(1)) && !isNaN(parseFloat(currentValue.slice(1)))) {
                        
                        currentValue = `${index == 0 || (!array[index - 1].endsWith('&nbsp;') && (indexLastMention == null || index - 1 !== indexLastMention)) ? '&nbsp;' : ''}${currentValue}${array.length - 1 == index ||  !array[index + 1].startsWith('&nbsp;') ? '&nbsp;' : ''}`
                        indexLastMention = index
                    }
                    return currentValue
                })
                console.log("Map result textMentionAroundSpace", textMentionAroundSpace)
                
                textMentionAroundSpace = textMentionAroundSpace.join("");
                
                // this.text = textMentionAroundSpace
                this.$emit('setText', textMentionAroundSpace)
                console.log('textMentionAroundSpace',textMentionAroundSpace, textMentionAroundSpace.length)
                if (forceUpdate) {
                    this.updateHtmlTextarea(true, true)
                }else if(innerText.length !== textMentionAroundSpace.length) {
                    this.updateHtmlTextarea(true, false)
                }

                console.log('----------------------- setTextareaContentValue END--------------------------')
            },

            clickTextarea(e) {
                console.log('----------------------- clickTextarea START--------------------------')
                if (!this.clickTextareaTimeout) {
                    this.clickTextareaTimeout = setTimeout(() => {

                        if (e.target.classList.contains('tag-mention') && e.target.getAttribute("idmention")) {
                            if (!this.mentions[parseInt(e.target.getAttribute("idmention"))]) return
                            this.idMentionSelected = parseInt(e.target.getAttribute("idmention"))
                            this.getTextareaRef().selection.selectedText = ''

                            this.addMode("addMentionMode",{
                                mention : {
                                    ...this.mentions[this.idMentionSelected],
                                    textDefault: this.mentions[this.idMentionSelected].textDefault ? this.mentions[this.idMentionSelected].textDefault.replaceAll('&nbsp;',' ') : ''
                                },
                                idMention : this.idMentionSelected
                            })
                        }
                        this.clickTextareaTimeout = null; // Réinitialise le timeout
                    }, 300); // 300ms de délai
                }else{
                    clearTimeout(this.clickTextareaTimeout);
                    this.clickTextareaTimeout = null; 
                }


                //permet de reformater le text (espace)

                //this.updateHtmlTextarea()

                console.log('----------------------- clickTextarea END--------------------------')
            },

            doubleclickTextarea(e) {
                console.log('doubleclickTextarea',e)
                if (e.target.classList.contains('tag-mention') && e.target.getAttribute("idmention")) {
                    if (!this.mentions[parseInt(e.target.getAttribute("idmention"))]) return


                    const range = document.createRange();
                    const selection = window.getSelection();

                    // Positionne le curseur au tout début du span
                    range.setStart(e.target.childNodes[0], e.target.childNodes[0].textContent.length);
                    range.collapse(true); // Assure que la plage est vide et le curseur est simplement placé

                    // Vide toutes les sélections actuelles
                    selection.removeAllRanges();

                    // Ajoute la nouvelle plage de sélection
                    selection.addRange(range);
                }
            },

            keyDownTextarea(e) {
                // console.log('----------------------------- keyDownTextarea START -------------------------------')
                //Pour positionner le cursor dans la mention a l'aide des touche "Arrow Right, Arrow Left"
                if (e.keyCode == 37 || e.keyCode == 39) {
                    const currentNode = this.getTextareaRef().getTextarea().childNodes[this.getTextareaRef().cursor.nodeIndex]
                    // console.log('currentNode', currentNode)

                    switch (e.keyCode) {
                        case 39:
                            // console.log('37 currentNode nextElementSibling', currentNode.nextElementSibling)

                            break;
                    
                        case 37:
                            
                            break;
                    }
                }
                // console.log('----------------------------- keyDownTextarea END -------------------------------')
            },

            onBlurTextarea(e) {
                // console.log("onBlurTextarea")
                // const text = this.text.replace(/\n|<br>|<\/br>/g, '');
                // const endingMention = this.getEndingMention(text)
                // if (endingMention) {
                //     this.$emit('setText',this.text.replace(`@${endingMention}`,`@${endingMention}&nbsp;`)) 
                //     this.updateHtmlTextarea()
                // }    
            },

            //ACTION

            clickMention() {
                if (!this.pagesSelected.find(p => ['facebook','instagram','inkedin', 'twitter'].includes(p.network))) return

                console.log('------------------- clickMention START ---------------------')
                // console.log("this.getTextareaRef().selection.selectedText",this.getTextareaRef().selection.selectedText)
                if (!this.getTextareaRef().selection.selectedText) {
                    console.log('test99', this.getTextareaRef().cursor.nodeIndex,this.getTextareaRef().getTextarea(), this.getTextareaRef().getTextarea().childNodes)
                    if (this.getTextareaRef().cursor.nodeIndex >= 0 && this.getTextareaRef().getTextarea().childNodes[this.getTextareaRef().cursor.nodeIndex]) {

                        const node = this.getTextareaRef().getTextarea().childNodes[this.getTextareaRef().cursor.nodeIndex]
                        console.log("clickMention node", node, node.parentElement.classList.contains('tag-mention'))
                        if (node.classList && node.classList.contains('tag-mention')) {
                            this.clickTextarea({target: node})
                            return
                        }

                        let text = node.textContent.replace(/\n|<br>|<\/br>/g, '').replaceAll('&nbsp;',' ')
                        
                        console.log("clickMention text =>", text)
                        
                        const offset = this.getTextareaRef().cursor.startOffset
                        node.textContent = text.slice(0, offset) + "@" + text.slice(offset);

                        // La touche qui a été pressée
                        const keyboardEvent = new KeyboardEvent('keydown', {
                            key: '@',
                            bubbles: true,
                            cancelable: true
                        });
                        
                        const inputEvent = new InputEvent('input', {
                            bubbles: true,
                            cancelable: true,
                            data: keyboardEvent.key, // Ajoute la touche pressée aux données de l'événement
                        });

                        Object.defineProperty(inputEvent, 'key', {
                            value: keyboardEvent.key,
                            enumerable: true,
                        });

                        console.log('displatchEvent', this.getTextareaRef().$refs[`textareaRef`], this.getTextareaRef().getTextarea())
                        this.getTextareaRef().getTextarea().dispatchEvent(inputEvent);

                    }else{
                        console.log('pasde node')
                    }
                    
                    this.getTextareaRef().restoreCursorPosition()
                }else{

                    const startTextReplaceBalise= this.getTextareaRef().selection.contentHtmlBeforeSelection.replace(/\n|<br>|<\/br>/g, '');
                    const endTextReplaceBalise= this.getTextareaRef().selection.contentHtmlAfterSelection.replace(/\n|<br>|<\/br>/g, '');
                    this.idMentionSelected = (new Date).getTime()
                    
                    const textMention = this.cleanTextMention(this.getTextareaRef().selection.selectedText.trim())
                    this.getTextareaRef().textareaValue = this.getTextareaRef().selection.contentHtmlBeforeSelection + `${!startTextReplaceBalise.length || this.getTextareaRef().selection.contentHtmlBeforeSelection.slice(-8) == "</span>" ? '&nbsp;' : ''}<span class="tag-mention no-select" idmention="${this.idMentionSelected}"  contenteditable="true"  spellcheck="false">@${textMention}</span>${!endTextReplaceBalise.length || this.getTextareaRef().selection.contentHtmlAfterSelection.slice(0,5) == "<span" ? '&nbsp;' : ''}` + this.getTextareaRef().selection.contentHtmlAfterSelection


                    const newMention = {
                        textDefault : textMention,
                        mention : {}
                    }
             
                    this.$emit('setMention',this.idMentionSelected, newMention)
                    this.addMode("addMentionMode",{
                        mention : {
                            ...newMention,
                            textDefault: newMention.textDefault ? newMention.textDefault.replaceAll('&nbsp;',' ') : ''
                        },
                        idMention : this.idMentionSelected
                    })
                    this.getTextareaRef().selection.selectedText = ''
                }

                console.log('------------------- clickMention END ---------------------')
            },

            closeSelectMention(idMention) {
                if (idMention !== this.idMentionSelected) return

                let value = Object.values(this.mentions[this.idMentionSelected] ? this.mentions[this.idMentionSelected].mention : [])
                if (!value || !value.length || !value.find(v => v ? true : false))  {
                  
                    if (this.mentions[this.idMentionSelected]) this.$emit('setText', this.text.replace(`@${this.idMentionSelected}`, `${this.keyAtPressedEvent.flag ? this.mentions[this.idMentionSelected].textDefault.slice(0, this.keyAtPressedEvent.indexInWord) + '@' + this.mentions[this.idMentionSelected].textDefault.slice(this.keyAtPressedEvent.indexInWord) : this.mentions[this.idMentionSelected].textDefault}`));
                    this.$delete(this.mentions, this.idMentionSelected);
                    this.$nextTick(() => {
                        this.updateHtmlTextarea();
                    })
                }else{
                    this.setTextareaContentValue(this.getTextareaRef().textareaValue)
                }
                this.$set(this.keyAtPressedEvent, 'flag', false)
                this.$nextTick(() => {
                    this.getTextareaRef().restoreCursorPosition()
                })
            },

            addMention(network, person, idMention) {
                console.log('-----------------------addMention----------------------------')
                if (!this.idMentionSelected || this.idMentionSelected !== idMention || !this.mentions[this.idMentionSelected]) return

                const isTextDefaultEmpty = !this.mentions[this.idMentionSelected].textDefault

                const mention = {
                    mention : {
                        ...this.mentions[this.idMentionSelected].mention,
                        [network]: person
                    },
                    textDefault : isTextDefaultEmpty ? person.name ? person.name : '' : this.mentions[this.idMentionSelected].textDefault
                }

                this.$emit('setMention',this.idMentionSelected, mention)
                if (isTextDefaultEmpty) this.updateHtmlTextarea()
                
               
            },

            addHashtags(network, hashtags, id) {
                if (id !== this.id) return
                if (this.getTextareaRef().cursor.nodeIndex >= 0 && this.getTextareaRef().getTextarea().childNodes[this.getTextareaRef().cursor.nodeIndex]) {

                    const node = this.getTextareaRef().getTextarea().childNodes[this.getTextareaRef().cursor.nodeIndex]
                    // console.log("clickMention node", node, node.parentElement.classList.contains('tag-mention'))
                    if (node.classList && node.classList.contains('tag-mention')) {
                        this.clickTextarea({target: node})
                        return
                    }

                    let text = node.textContent.replace(/\n|<br>|<\/br>/g, '').replaceAll('&nbsp;',' ')

                    // console.log("clickMention text =>", text)

                    const offset = this.getTextareaRef().cursor.startOffset
                    const textadd = hashtags.map(hashtag => `#${hashtag}`).join(" ")
                    node.textContent = text.slice(0, offset) + textadd + text.slice(offset);

                    // La touche qui a été pressée
                    const keyboardEvent = new KeyboardEvent('keydown', {
                        key: textadd,
                        bubbles: true,
                        cancelable: true
                    });

                    const inputEvent = new InputEvent('input', {
                        bubbles: true,
                        cancelable: true,
                        data: keyboardEvent.key, // Ajoute la touche pressée aux données de l'événement
                    });

                    Object.defineProperty(inputEvent, 'key', {
                        value: keyboardEvent.key,
                        enumerable: true,
                    });

                    // console.log('displatchEvent', this.getTextareaRef().$refs[`textareaRef`])
                    this.getTextareaRef().$refs[`textareaRef`].dispatchEvent(inputEvent);

                }
            },

            updateHtmlTextarea(focus = true, restorePreviousCursor = false) {
                //important
                //quand this.getTextareaRef().textareaValue change le composant executera setTextareaContentValue
                console.log('----------------------------- updateHtmlTextarea START -------------------------------')

                // const endingMention = this.getEndingMention(this.text)

                // if (endingMention) {
                //     this.$emit('setText', this.text.replace(`@${endingMention}`,`@${endingMention}&nbsp;`))
                // }

                let newValue = this.text.replace(/@(\d{13})/g, (match, id) => {
                        const mention = this.mentions[id];
                        if (mention) {
                            return `<span class="tag-mention no-select" idmention="${id}" contenteditable="true" spellcheck="false">@${mention.textDefault.trim()}</span>`
                        }
                        return match;
                }).replace(/\\n/g, '<br>')

               
                console.log("newValue2", this.getTextareaRef().getTextarea().innerHTML)
                // console.log('updateHtmlTextarea', '1. textareaValue','2. curentInnerHtml','3. new value')
                // console.log(this.getTextareaRef().textareaValue)
                // console.log(this.getTextareaRef().getTextarea().innerHTML)
                // console.log(newValue)
                // this.setTextareaContentValue(newValue)
                if (this.getTextareaRef().getTextarea().innerHTML !== newValue) {
                    
                    console.log('set new value', newValue)
                    this.$set(this.getTextareaRef(), 'textareaValue', newValue);

                    if (focus) {
                        this.$nextTick(() => {
                            this.getTextareaRef().restoreCursorPosition(restorePreviousCursor)
                        })
                    }
                }

                console.log('----------------------------- updateHtmlTextarea END -------------------------------')
                // this.getTextareaRef().selection.selectedText = ''

            },

            //UTILS

            getTextareaRef() {
                return this.$refs.textarea
            },

            getEndingMention(text){
                //renvoi false si le text ne se termine pas par une mention, sinon renvoi l'id de la mention

                text = this.text.replace('\n','').replace('<br>','').replace('</br>','');
                // console.log("getEndingMention text =>", '|'+text+'|')
                if (text.length >= 14) {
                    const textlastId = text.slice(-13)
                    if (!isNaN(textlastId) && !isNaN(parseFloat(textlastId)) && text.slice(-14,-13) == "@") {
                        return textlastId
                    }
                }
                return false
            },

            findOneMentionPosition(text,last = false){
                console.log("findOneMentionPosition", text)
                const regex = /@(\d{13})/g;
                let match;
                let lastPosition = -1;

                while ((match = regex.exec(text)) !== null) {
                    lastPosition = match.index;
                    if (!last) return lastPosition;
                }

                return lastPosition;
            },

            cleanTextMention(textMention) {
                const blacklist = ['<br>', '</br>', '@', '\n', '\\n'];

                blacklist.map(t => {
                    if (textMention.includes(t)) {
                        textMention = textMention.replaceAll(t, '')
                    }
                }) 

                return textMention
            },

            /////////////// Textarea Content END ///////////////

            addMode(mode,data = {}) {
                EventBus.$emit("postCreatorAddMode", mode, data);
            },

            removeMention(network, idMention){
                if (!this.idMentionSelected || this.idMentionSelected !== idMention || !this.mentions[this.idMentionSelected]) return
                this.$delete(this.mentions[this.idMentionSelected].mention, network);
            },

            async searchMention(value, network, idEvent, idMention) {
                if (!this.idMentionSelected || idMention !== this.idMentionSelected) return
                let page = null
                let isUrl = false
                switch (network) {
                    case 'instagram':
                        page = this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created) || this.pagesSelected.find(p => p.network == 'instagram' && p.bot_status)
                        break;

                    case 'facebook':
                        page = this.pagesSelected.find(p => p.network == 'facebook' && (p.bot_status || true))
                        break;

                    case 'twitter':
                        page = this.pagesSelected.find(p => p.network == 'twitter' && p.bot_status)

                        break;

                    case 'linkedin':
    
                        page = this.pagesSelected.find(p => p.network == 'linkedin' && p.bot_status && p.story_config && p.story_config.created) || this.pagesSelected.find(p => p.network == 'linkedin' && p.bot_status)
                        isUrl = false

                        if (page) {
                            if (value.includes("linkedin.com/company")) {
                                isUrl = true
                                value = value.split('/')
                                let index = value.findIndex(v => v == 'company')
                                value = value[index+1] ? value[index+1] : ''
                            }else{
                                if (!page.story_config || !page.story_config.created) {
                                    //conciergerie désactivé
                                    value = value.replaceAll(' ','-')
                                    isUrl = true
                                }

                            }
                        }
                    
                        break;
                }

                let result = []
                if (page && value) {
                    result = (await this.getMentionsByApi(page.id, value, isUrl)).body.mentions
                }
                EventBus.$emit("resultSearchFromSelectMention", result, idEvent)
            },

            clickHashtag() {
                if (this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)) {
                    this.addMode("addHashtagMode", {
                        id: this.id
                    })
                }            
            },

            async searchHashtags(value, network, idEvent, id) {
                if (id !== this.id) return
                let page = null
                switch (network) {
                    case 'instagram':
                        page = this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)
                        break;
                }

                let result = []
                if (page && value) {
                    result = (await this.getHashtagsByApi(page.id, value)).body.hashtags
                }
                EventBus.$emit("resultSearchFromSelectHashtags", result, idEvent)
            },
        },

        computed: {
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'];
            },
        },

        beforeDestroy() {
            EventBus.$off('eventCloseSelectMention', this.closeSelectMention);
            EventBus.$off('eventSearchFromSelectMention', this.searchMention);
            EventBus.$off('eventClickSelectMention', this.addMention);
            EventBus.$off('eventRemoveSelectMention', this.removeMention);
            EventBus.$off('eventSearchFromSelectHashtags', this.searchHashtags);
            EventBus.$off('eventApplyFromSelectHashtags', this.addHashtags);       
        },
    }
</script>

<style lang="scss" scoped>

</style>